export default __webpack_public_path__ + "assets/GTLogo_highRes.png";